import { FeedType } from '@/domain/live';

/** Legacy tablesleague partner iframe (FeedType.Standard). */
export const TABLES_LEAGUE_IFRAME_URL =
  'https://www.tablesleague.com/iframe_page/?id=bf291421f829aaf551e204a20271a2f0';

/** Legacy STATSCORE prematch WidgetGroup id (FeedType.LSports). */
export const STATSCORE_PREMATCH_WIDGET_GROUP_ID = '6305de51e851aa6293485b40';

/** Official STATSCORE embedder (exposes `STATSCOREWidgets.onLoad`). */
export const STATSCORE_EMBEDDER_SCRIPT_URL =
  'https://wgt-s3-cdn.statscore.com/bundle/EmbederESM.js';

export const STATSCORE_EMBEDDER_SCRIPT_ID = 'STATSCOREWidgetsEmbederScript';

const SPORTRADAR_MATCH_STATS_BASE = 'https://s5.sir.sportradar.com/betica';

const DESKTOP_POPUP_FEATURES = 'popup=1,width=800,height=600,left=100,top=100';

export type PrematchStatisticsResult =
  | { kind: 'opened' }
  | { kind: 'blocked' }
  | { kind: 'tablesleague' }
  | { kind: 'statscore'; eventId: number; language: string };

export type OpenPrematchStatisticsOptions = {
  eventId: number;
  feedType?: number | null;
  /** BCP-47 or short code; reduced to the language subtag. */
  language?: string | null;
  isMobile?: boolean;
};

/** First subtag of a locale, lowercased (legacy `Language.Short`). */
export function languageShort(language?: string | null): string {
  const raw = (language ?? 'en').trim();
  if (!raw) return 'en';
  return raw.split(/[-_]/)[0]?.toLowerCase() || 'en';
}

/** Sportradar SIR match hub used for UOF (and unknown) feed types. */
export function buildSportradarMatchStatsUrl(
  eventId: number | string,
  language: string,
): string {
  return `${SPORTRADAR_MATCH_STATS_BASE}/${languageShort(language)}/match/${eventId}`;
}

/**
 * Prematch stats / league-table entry point — mirrors legacy
 * `SportsApp.Tools.Statistics` (FeedType branch).
 */
export function openPrematchStatistics(
  options: OpenPrematchStatisticsOptions,
): PrematchStatisticsResult {
  const language = languageShort(options.language);
  const feedType = options.feedType ?? FeedType.UOF;

  if (feedType === FeedType.LSports) {
    return { kind: 'statscore', eventId: options.eventId, language };
  }

  if (feedType === FeedType.Standard) {
    return { kind: 'tablesleague' };
  }

  const url = buildSportradarMatchStatsUrl(options.eventId, language);
  const features = options.isMobile ? undefined : DESKTOP_POPUP_FEATURES;
  const handle = features
    ? window.open(url, '_blank', features)
    : window.open(url, '_blank');

  return handle ? { kind: 'opened' } : { kind: 'blocked' };
}
